<!--
 * @Author: DY
 * @Date: 2021-05-18 16:38:39
 * @LastEditTime: 2021-07-09 10:47:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\productionRatio\mixtureRatioApprovalOpinion.vue
-->
<template>
    <v-touch @swiperight="onClickLeft" class="wrapper">
        <div class="mixtureRatioApprovalOpinion">
            <van-nav-bar
                title="审批意见列表"
                left-text="关联配比"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <ul class="opinionListContent">
                <template v-for="(item, index) in approvalCommentsList">
                    <li :key="`approvalComments_${index}`">
                        <h5>{{ item.line_name }}</h5>
                        <p>{{ item.approval_opinion }}</p>
                        <div class="essentialInfo">
                            <span class="iconfont icon04gerenfill">审批人：{{ item.send_user_name }}</span>
                            <span>{{ item.approval_time }}</span>
                        </div>
                        <div
                            class="cornerMarker"
                            :class="{
                                'pendingTrial': item.approval_status == 0,
                                'adopt': item.approval_status == 1,
                                'noAdopt': item.approval_status == 2
                            }"
                        ></div>
                    </li>
                </template>
            </ul>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 配比审批意见
    name: 'mixture-ratio-approval-opinion',
    components: {},
    props: {},
    data() {
        return {
            // 任务单号
            task_number: '',
            // 审批意见数据
            approvalCommentsList: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 任务单号
        this.task_number = this.$route.params.task_number;
        // 初始化审批意见
        this.initApprovalComments();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 初始化审批意见
        initApprovalComments() {
            this.$axios
                .get(`/interfaceApi/production/productformula/formula_approval/list/${this.task_number}`)
                .then(res => {
                    if ((res || []).length > 0) {
                        this.approvalCommentsList = res;
                    } else {
                        this.$toast('暂无审批意见！');
                    }
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus" scoped>
.mixtureRatioApprovalOpinion
    height 100%
    .opinionListContent
        height calc(100% - 44rpx)
        background #fff
        padding 15rpx
        overflow-y auto
        background #F3F3F3
        li
            padding 15rpx
            position relative
            margin-bottom 15rpx
            background #fff
            border-radius 4px
            overflow hidden
            &:last-child
                margin-bottom 0
            h5
                font-size 16rpx
                line-height 16rpx
                color #333333
                margin-bottom 7rpx
            p
                font-size 14rpx
                color #7D7D7D
                margin-bottom 10rpx
            .essentialInfo
                display flex
                justify-content space-between
                span
                    color #979EA7
                    font-size 12rpx
            .cornerMarker
                width 40rpx
                height 40rpx
                position absolute
                top 0
                right 0
                background-repeat no-repeat
                background-size 100%
                &.pendingTrial
                    background-image url(./images/corner_mark_no_approval.png)
                &.adopt
                    background-image url(./images/corner_mark_pass.png)
                &.noAdopt
                    background-image url(./images/corner_mark_no_pass.png)
</style>